"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title$ = exports.Title$outboundSchema = exports.Title$inboundSchema = void 0;
exports.titleToJSON = titleToJSON;
exports.titleFromJSON = titleFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const titleownership_js_1 = require("./titleownership.js");
const titlepolygon_js_1 = require("./titlepolygon.js");
/** @internal */
exports.Title$inboundSchema = z
    .object({
    class_of_title: z.nullable(z.string()),
    estate_interest: z.nullable(z.string()),
    ownership: z.nullable(titleownership_js_1.TitleOwnership$inboundSchema),
    polygons: z.array(titlepolygon_js_1.TitlePolygon$inboundSchema),
    title_number: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "class_of_title": "classOfTitle",
        "estate_interest": "estateInterest",
        "title_number": "titleNumber",
    });
});
/** @internal */
exports.Title$outboundSchema = z.object({
    classOfTitle: z.nullable(z.string()),
    estateInterest: z.nullable(z.string()),
    ownership: z.nullable(titleownership_js_1.TitleOwnership$outboundSchema),
    polygons: z.array(titlepolygon_js_1.TitlePolygon$outboundSchema),
    titleNumber: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        classOfTitle: "class_of_title",
        estateInterest: "estate_interest",
        titleNumber: "title_number",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Title$;
(function (Title$) {
    /** @deprecated use `Title$inboundSchema` instead. */
    Title$.inboundSchema = exports.Title$inboundSchema;
    /** @deprecated use `Title$outboundSchema` instead. */
    Title$.outboundSchema = exports.Title$outboundSchema;
})(Title$ || (exports.Title$ = Title$ = {}));
function titleToJSON(title) {
    return JSON.stringify(exports.Title$outboundSchema.parse(title));
}
function titleFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Title$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Title' from JSON`);
}
//# sourceMappingURL=title.js.map